export default {
  /**
   * @type {string} メイン画面
   */
  summary: '/admin/summary/',
};
